export enum BookingStatus {
  WAITING = 'waiting',
  PAYMENT = 'payment',
  APPROVED = 'approved',
  CANCELLED = 'cancelled',
  DONE = 'done'
}
